import { FC } from 'react'
import {
  FormInputErrorMessage,
  FlexDiv
} from 'src/components/application/formComponents/styles'
import OptionButton from 'src/components/basic/OptionButton'
import { useErrors } from 'src/context/errors';

interface Props {
  isIncorrect?: boolean;
  option?: boolean;
  setOption: (option: boolean) => void;
  errorCode?: string;
}

const OptionButtonsFormItem: FC<Props> = ({
  option,
  setOption,
  isIncorrect,
  errorCode ='',
}) => {
  const { hasError, getErrorMessage } = useErrors()
  isIncorrect = hasError(errorCode) || isIncorrect


  return (
    <FlexDiv dir="column" margin='24px 0 0 0' gap="4px" height='fit-content'>
      <FlexDiv gap="24px" height='fit-content'>
        <OptionButton
          checked={option === true}
          onChange={() => setOption(true)}
          isIncorrect={isIncorrect && option === undefined}
          errorCode={errorCode}
        >
          Yes
        </OptionButton>
        <OptionButton
          checked={option === false}
          onChange={() => setOption(false)}
          isIncorrect={isIncorrect && option === undefined}
          errorCode={errorCode}
        >
          No
        </OptionButton>
      </FlexDiv>
      
    </FlexDiv>
  )
}

export default OptionButtonsFormItem